import Api from "../apis/Api"

const getActionInstance = (component) => {
    if (component.subinstance && !component.main) {
        return component.subinstance;
    }
    if (component.instance?.subinstance && !component.main) {
        return component.instance.subinstance;
    }
    if (component.instance) {
        return component.instance;
    }
    return component.item;
};

export const OpenWPLoginModalMixin = {
    data: function () {
        return {
            checkingWpLogin: false
        }
    },
    methods: {
        openWPLoginModal: function () {
            this.checkingWpLogin = true;
            let instance = getActionInstance(this);
            Api.get(`/instances/${instance.id}/wordpress/users?role=administrator&for_sso=1`)
                .then((response) => {
                    let options = [];
                    for (let user of response.data.data) {
                        const email = user.user_email || user.email || "";
                        options.push({ label: `${user.display_name} - ${email}`, value: user.id });
                    }
                    this.$emit("action-button-wplogin", {
                        application: instance,
                        options: options,
                    });
                })
                .catch((error) => {
                    this.$store.dispatch("addAlert", {
                        success: false,
                        errorMessage: Api.getErrorMessage(error),
                    });
                })
                .finally(() => {
                    this.checkingWpLogin = false;
                }); 
        },
    }
}

export const OpenUpdatesModalMixin = {
    data: function () {
        return {
            checkingUpdates: false
        }
    },
    methods: {
        openUpdateModal: function () {
            this.checkingUpdates = true;
            let instance = getActionInstance(this);
            Api.get(`/instances/${instance.id}/wordpress/updates`)
                .then((response) => {
                    const { wp_version, available_updates } = response.data.data;
                    this.$emit("action-button-update", {
                        application: instance,
                        availableUpdates: available_updates,
                        wpVersion: wp_version,
                    });
                })
                .catch((error) => {
                    const errorMsg = Api.getErrorMessage(error);
                    this.$store.dispatch("addAlert", {
                        success: false,
                        errorMessage: errorMsg,
                    });
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.checkingUpdates = false;
                    });
                });
        },
    }
}

export const OpenPushToLiveModalMixin = {
    data: function () {
        return {
            loadingPushToLive: false
        }
    },
    methods: {
        openPushToLiveModal: function () {
            this.loadingPushToLive = true;
            this.$emit("action-button-push-to-live", {
                loadingState: this.loadingPushToLive
            });

            Api.get(`/instances/${this.instance.id}/push-to-live`)
                .then((response) => {
                    this.$emit("action-button-push-to-live", {
                        application: this.instance,
                        databaseDiff: response.data.data,
                    });
                })
                .catch(() => {
                    this.$emit("action-button-push-to-live", {
                        application: this.instance,
                        databaseDiffUnavailable: true,
                    });
                })
                .finally(() => {
                    this.$nextTick(() => {
                        this.loadingPushToLive = false;
                    });
                });
        },
    }
}

export const OpenPushToStagingModalMixin = {
    data: function () {
        return {
            loadingPushToStaging: false
        }
    },
    methods: {
        openPushToStagingModal: function () {
            this.loadingPushToStaging = true;
            this.$emit("action-button-push-to-staging", {
                loadingState: this.loadingPushToStaging
            });

            Api.get(`/instances/${this.instance.id}/push-to-staging`)
              .then((response) => {
                  this.$emit("action-button-push-to-staging", {
                      application: this.instance,
                      databaseDiff: response.data.data,
                  });
              })
              .catch(() => {
                  this.$emit("action-button-push-to-staging", {
                      application: this.instance,
                      databaseDiffUnavailable: true,
                  });
              })
              .finally(() => {
                  this.$nextTick(() => {
                      this.loadingPushToStaging = false;
                  });
              });
        },
    }
}
